import React, { Component } from "react";
import PlacesAutocomplete, {
  geocodeByAddress
} from "react-places-autocomplete";
import { mapAddressFromGooglePlacesApiResponse } from "../../../_utils";

export default class BirthPlaceInput extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.readOnly) {
      return { address: nextProps.value };
    } else {
      return null;
    }
  }
  state = { address: "" };
  handleChange = address => {
    this.setState({ address });
  };

  handleSelect = address => {
    const { onSelect } = this.props;

    geocodeByAddress(address).then(results => {
      const updatedAddress = mapAddressFromGooglePlacesApiResponse(results[0]);
      this.setState({ address: updatedAddress.formatted_address }, () => {
        onSelect(updatedAddress);
      });
    });
  };
  render() {
    const { label, readOnly } = this.props;
    return (
      <div className="form-group form-group-custom">
        {label}
        <div className="form-control-clear-wrap">
          <PlacesAutocomplete
            value={this.state.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}
          >
            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
              <div
                className={
                  suggestions.length === 0 ? "Select" : "Select is-open"
                }
              >
                <input
                  {...getInputProps({
                    placeholder: "-",
                    className: "form-control",
                    disabled: readOnly
                  })}
                />
                <div
                  className={
                    suggestions.length === 0 ? "" : "Select-menu-outer"
                  }
                >
                  <div className="Select-menu">
                    {suggestions.map((suggestion, index) => {
                      const className = suggestion.active
                        ? "Select-option is-focused"
                        : "Select-option ";
                      // inline style for demonstration purpose

                      return (
                        <div
                          key={index}
                          {...getSuggestionItemProps(suggestion, {
                            className
                          })}
                        >
                          {suggestion.description}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </PlacesAutocomplete>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/GooglePlacesAutocomplete/index.js